import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import tenkoAssociationType from "@/types/responses/getIttenkoAssociation";
import DeleteIcon from "@/components/TenkoAssociations/DeleteIcon.vue";
import EditIcon from "@/components/TenkoAssociations/EditIcon.vue";
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
import { formatDateTime } from "@/services/functions";
import accountType from "@/types/account";
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountListRow',
  props: {
    tenkoAssociations: {},
    account: {},
    isUpdateAuthority: { type: Boolean },
    isDeleteAuthority: { type: Boolean }
  },
  emits: ['openUpdateModal', 'openDeleteModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const searchTenkoAssociation = computed(() => {
  return props.tenkoAssociations.find((tenkoAssociation) => {
    return tenkoAssociation.operation_office_id === props.account.officeable_id
      && tenkoAssociation.driver_id === props.account.driver_id;
  });
})

function employeeCode() {
  const tenkoAssociation = searchTenkoAssociation.value;
  if (tenkoAssociation) {
    return tenkoAssociation.employee_cd;
  }
  const driverId = String(props.account.driver_id);
  return driverId.padStart(10,"0")
}

function updatedAt() {
  const tenkoAssociation = searchTenkoAssociation.value;
  const updatedOrCreatedAt = tenkoAssociation?.updated_at ?? tenkoAssociation?.created_at;

  if (tenkoAssociation && updatedOrCreatedAt) {
    return formatDateTime(new Date(updatedOrCreatedAt));
  }
  return i18n.global.t('common.notApplicable');
}

function openUpdateModal(account: accountType, employeeCd: string) {
  return emits('openUpdateModal', account, employeeCd, !!searchTenkoAssociation.value)
}

function openDeleteModal(tenkoAssociation: tenkoAssociationType) {
  return emits('openDeleteModal', tenkoAssociation)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, _toDisplayString(__props.account.id), 1),
    _createElementVNode("td", null, _toDisplayString(__props.account.full_name), 1),
    _createElementVNode("td", null, _toDisplayString(__props.account.email), 1),
    _createElementVNode("td", null, _toDisplayString(__props.account.officeable.operation_office_name), 1),
    _createElementVNode("td", null, _toDisplayString(__props.account.department_target_name), 1),
    _createElementVNode("td", null, _toDisplayString(__props.account.driver_id), 1),
    _createElementVNode("td", null, _toDisplayString(employeeCode()), 1),
    _createElementVNode("td", null, _toDisplayString(updatedAt()), 1),
    _createElementVNode("td", null, [
      _createVNode(DisplayFullnameFromUpdatedBy, {
        updatedBy: searchTenkoAssociation.value?.updated_by ?? null
      }, null, 8, ["updatedBy"])
    ]),
    _createElementVNode("td", null, [
      (props.isUpdateAuthority)
        ? (_openBlock(), _createBlock(EditIcon, {
            key: 0,
            account: __props.account,
            employeeCode: employeeCode(),
            onOpenUpdateModal: openUpdateModal
          }, null, 8, ["account", "employeeCode"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", null, [
      (props.isDeleteAuthority)
        ? (_openBlock(), _createBlock(DeleteIcon, {
            key: 0,
            tenkoAssociation: searchTenkoAssociation.value,
            onOpenDeleteModal: openDeleteModal
          }, null, 8, ["tenkoAssociation"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})